<div
  class="finance px-1 app-text-bold app-text-white my-1 py-0 d-flex justify-content-between primary-section-header-block align-items-center">
  <app-deal-type-selector (submitDealType)="submitDealType.emit($event)"></app-deal-type-selector>
</div>
